export default __webpack_public_path__ + "static/media/PolygonSwap.24d21399.svg";